export { getDefaultBeatifiedScrollbar } from './getDefaultBeatifiedScrollbar'
